import React, { Component, createRef } from "react";
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import DashboardHeader from "../../Header/DashboardHeader";
import DashboardFooter from "../../Footer/DashboardFooter";
import DashboardLeftMenu from "../../Dashboard/DashboardLeftMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Dialog from "react-dialog";

import {
  faCalendarCheck,
  faInfoCircle,
  faMobile,
  faAddressBook,
  faBan,
  faDownload,
  faSearch,
  faExclamationCircle,
} from "@fortawesome/free-solid-svg-icons";
import EmptyImg from "../../Dashboard/assets/img/create-project.png";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import JSONPretty from "react-json-pretty";
import "react-json-pretty/themes/monikai.css";
import { HOST_URL, NODE_HOST_URL_v1 } from "../api/Api";
import Axios from "../../../axios/Axios";
import { handleUserLog } from "../../Utils/Utils";
class SmsDetailReports extends Component {
  constructor(props) {
    const lStorage = JSON.parse(localStorage.getItem("login"));
    const lsAdmin = JSON.parse(localStorage.getItem("admin"));
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    super(props);
    this.state = {
      adminDtl: lsAdmin || null,
      user_id: userId,
      token: userToken,
      smsDetailsReportList: "",
      emailDetailsReportList: "",
      voiceDetailsReportList: "",
      responceMessage: "",
      status: "",
      senderid: "",
      mobile: "",
      email: "",
      channel: this.props.match.params.channel,
      dateFrom: this.props.match.params.dateFrom,
      dateTo: this.props.match.params.dateTo,
      SelecteddateFrom: "",
      SelecteddateTo: "",
      apiResponse: [],
      isDialogOpen: false,
      successMessage: false,
      errorMessage: "",
      bgColor: "",
      isPopoverOpen: null,
      popoverPosition: "bottom",
      isLoading: false,

    };
    this.popupRef = React.createRef();
    // this.checkResponce = this.checkResponce.bind(this)
  }

  componentDidMount() {
    this.detailsReport();
    // this.filterDetailsWithChannel()
    document.addEventListener('mousedown', this.handleClickOutside);

  }


  componentWillUnmount() {
    // Clean up event listener when the component unmounts
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.popupRef.current && !this.popupRef.current.contains(event.target)) {
      this.setState({ isPopoverOpen: null, });
    }
  };


  handleButtonClick = (index) => {
    this.setState({
      isPopoverOpen: index,
    });
  };

  togglePopover = (i, event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    // Determine whether there is more space above or below
    const popoverPosition = rect.bottom + 200 > viewportHeight ? "top" : "bottom";

    this.setState({ isPopoverOpen: i, popoverPosition });
  };

  detailsReport = async () => {
    let paramData = {
      user_id: this.state.user_id,
      method: "details",
      channel: "sms",
      token: this.state.token,
      date_from: this.state.dateFrom,
      date_to: this.state.dateTo,
      mobile: this.state.mobile,
      senderid: this.state.senderid,
      status: this.state.status
    }
    // let { data } = await Axios.post(`${HOST_URL}/user_report.php`, paramData)
    let { data } = await Axios.post(`https://napi3.authkey.io/api2/v1/api_report`, paramData)
    if (data.success === true) {
      if (this.state.channel === "sms") {
        this.setState({ smsDetailsReportList: data.message });
      }
    } else {
      this.setState({ responceMessage: data.message });
    }
  }

  // filterDetailsWithChannel = async () => {
  //   this.setState({ smsDetailsReportList: "" });
  //   let paramData = {
  //     user_id: this.state.user_id,
  //     method: "details",
  //     channel: "sms",
  //     token: this.state.token,
  //     date_from: this.state.dateFrom,
  //     date_to: this.state.dateTo,
  //     mobile: this.state.mobile,
  //     senderid: this.state.senderid,
  //     status: this.state.status
  //   }
  //   // let { data } = await Axios.post(`${HOST_URL}/user_report.php`, paramData)
  //   let { data } = await Axios.post(`https://napi.authkey.io/api2/v1/api_report`, paramData)
  //   if (data.success === true && data.message && data.message.length > 0) {

  //     if (this.state.channel === "sms") {
  //       this.setState({
  //         smsDetailsReportList: data.message,
  //         successMessage: false,
  //         errorMessage: "",
  //       });
  //     }
  //   } else {
  //     this.setState({
  //       successMessage: true,
  //       errorMessage: data.message,
  //       bgColor: "alert alert-danger alert-dismissible",
  //     });
  //   }
  // }

  // dataDownload() {
  //   this.setState({ successMessage: false });

  //   const date1 = new Date(this.state.dateFrom);
  //   const date2 = new Date(this.state.dateTo);
  //   const Difference_In_Time = date2.getTime() - date1.getTime();
  //   const Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

  //   if (Math.trunc(Difference_In_Days) <= 15) {
  //     // Create FormData
  //     // const formData = new FormData();
  //     // formData.append("user_id", this.state.user_id);
  //     // formData.append("method", "download");
  //     // formData.append("channel", "sms");
  //     // formData.append("token", this.state.token);
  //     // formData.append("date_from", this.state.dateFrom);
  //     // formData.append("date_to", this.state.dateTo);

  //     // Send POST with FormData and download file
  //     // fetch(`${HOST_URL}/user_report.php`, {
  //     //   method: "POST",
  //     //   body: formData
  //     // })

  //     let paramData = {
  //       user_id: this.state.user_id,
  //       method: "download",
  //       channel: "sms",
  //       token: this.state.token,
  //       date_from: this.state.dateFrom,
  //       date_to: this.state.dateTo
  //     }
  //     fetch(`https://napi.authkey.io/api2/v1/api_report`, {
  //       method: "GET",
  //       body: paramData
  //     })
  //       .then(response => {
  //         if (!response.ok) throw new Error("Network response was not ok");
  //         return response.blob();
  //       })
  //       .then(blob => {
  //         const url = window.URL.createObjectURL(blob);
  //         const link = document.createElement("a");
  //         link.href = url;
  //         link.download = "user_report.csv"; // Change filename if needed
  //         document.body.appendChild(link);
  //         link.click();
  //         link.remove();
  //         window.URL.revokeObjectURL(url);
  //       })
  //       .catch(error => {
  //         console.error("Download failed:", error);
  //       });

  //   } else {
  //     document.querySelector("body").scrollTo(0, 0);
  //     this.setState({
  //       successMessage: true,
  //       bgColor: "alert alert-danger alert-dismissible",
  //       errorMessage: `Please go to the Download Center to download data older than 15 days.`,
  //     });
  //   }
  // }

  dataDownload() {
    this.setState({ successMessage: false });

    const date1 = new Date(this.state.dateFrom);
    const date2 = new Date(this.state.dateTo);
    const Difference_In_Time = date2.getTime() - date1.getTime();
    const Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

    if (Math.trunc(Difference_In_Days) <= 15) {

      const params = new URLSearchParams({
        user_id: this.state.user_id,
        method: "download",
        channel: "sms",
        token: this.state.token,
        date_from: this.state.dateFrom,
        date_to: this.state.dateTo
      });

      fetch(`https://napi.authkey.io/api2/v1/api_report?${params.toString()}`, {
        method: "GET"
      })
        .then(response => {
          if (!response.ok) throw new Error("Network response was not ok");
          return response.blob();
        })
        .then(blob => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "user_report.csv";
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch(error => {
          console.error("Download failed:", error);
        });


    } else {
      document.querySelector("body").scrollTo(0, 0);
      this.setState({
        successMessage: true,
        bgColor: "alert alert-danger alert-dismissible",
        errorMessage: `Please go to the Download Center to download data older than 15 days.`,
      });
    }
  }


  dateFrom = (date) => {
    let dated =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1) +
      "-" +
      ("0" + date.getDate()).slice(-2);
    this.setState({
      dateFrom: dated,
      SelecteddateFrom: date,
    });
  };

  dateTo = (date) => {
    let dated =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1) +
      "-" +
      ("0" + date.getDate()).slice(-2);
    this.setState({
      dateTo: dated,
      SelecteddateTo: date,
    });
  };

  setStatus() {
    if (this.state.channel === "sms") {
      return (
        <>
          <option value=""> All </option>
          <option value="delivered"> Delivered </option>
          <option value="failed"> Failed </option>
          <option value="submitted"> Submitted </option>
        </>
      );
    } else {
      return (
        <>
          <option value=""> No Channel Selected </option>
        </>
      );
    }
  }

  checkResponce = (e, route) => {
    Axios.post(`${HOST_URL}/user_report.php`, {
      user_id: this.state.user_id,
      method: "request_status",
      token: this.state.token,
      logid: e
    })
      .then((response) => {
        const result = response.data;
        if (result.success === true) {
          this.openDialog();

          const updatedata = result.message.map((data) => ({
            ...data,
            route_id: route
          }));

          this.setState({ apiResponse: updatedata });
        } else {
          this.setState({
            successMessage: true,
            errorMessage: result.message,
            bgColor: "alert alert-danger alert-dismissible"
          });
        }
      })
      .catch((error) => {
        console.error(error);
        this.setState({
          successMessage: true,
          errorMessage: "Something went wrong",
          bgColor: "alert alert-danger alert-dismissible"
        });
      });
  };

  isWithinLastSixDays(submittedOn) {
    const submittedDate = new Date(submittedOn.split(" ")[0]); // Get YYYY-MM-DD part
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Strip time

    // Get date 6 days ago
    const sixDaysAgo = new Date(today);
    sixDaysAgo.setDate(today.getDate() - 6);

    // If submitted date is after or equal to six days ago, return true
    return submittedDate >= sixDaysAgo;
  }



  openDialog = () => this.setState({ isDialogOpen: true });

  handleClose = () => this.setState({ isDialogOpen: false });

  render() {
    console.log(this.props.match.params.dateFrom);

    return (
      <div className="wrapper">
        <DashboardLeftMenu />
        <div className="main">
          <DashboardHeader />
          <main className="content">
            <div className="container-fluid p-0">
              <div className=" mb-2 mb-xl-3">
                <div className="col-auto d-none d-sm-block">
                  <h3>
                    <strong>Reports </strong> Details{" "}
                  </h3>
                </div>
              </div>
              <div className="">
                <div className="card">
                  <div className="">
                    <h5 className="card-title  mt-5">
                      <div className="col-auto ml-auto text-right mt-n1">
                        <nav className="text-center" aria-label="breadcrumb">
                          <ol className="breadcrumb bg-transparent p-0 mt-1 mb-0">
                            <Link to="/dashboard/sms-report">
                              <li onClick={() => handleUserLog("" , "clicked_today_summary_tab" , "sms" , "User Click on Today Summary tab in report" , "sms_report" , "" , "")} className="breadcrumb-item">
                                {" "}
                                Today's Summary{" "}
                              </li>{" "}
                            </Link>
                            <Link
                              to={
                                "/dashboard/sms-detail-reports/" +
                                "sms/" +
                                this.state.dateFrom +
                                "/" +
                                this.state.dateTo
                              }
                            >
                              {" "}
                              <li onClick={() => handleUserLog("" , "clicked_detailed_reports_tab" , "sms" , "User Click on Detailed Reports tab in report" , "sms_report" , "" , "")} className="breadcrumb-item active">
                                {" "}
                                Detailed Reports{" "}
                              </li>{" "}
                            </Link>
                            <Link
                              to={
                                "/dashboard/sms-template-summary"
                              }
                            >
                              {" "}
                              <li onClick={() => handleUserLog("" , "clicked_template_summary_tab" , "sms" , "User Click on Template Summary tab in report" , "sms_report" , "" , "")} className="breadcrumb-item ">
                                {" "}
                                Template Summary{" "}
                              </li>{" "}
                            </Link>
                          </ol>
                        </nav>
                      </div>
                    </h5>
                  </div>

                  <div className="card-body">
                    {this.state.successMessage ? (
                      <div className={this.state.bgColor} role="alert">
                        <button
                          type="button"
                          className="close"
                          data-dismiss="alert"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">×</span>
                        </button>
                        <div className="">{this.state.errorMessage}
                          <Link to="/dashboard/download-centre">
                            Download Centre
                          </Link>
                        </div>
                      </div>
                    ) : null}

                    {this.state.isDialogOpen && (
                      <Dialog
                        modal={true}
                        title="API Requets / Response Status"
                        isDraggable={true}
                        onClose={this.handleClose}
                        maxWidth={"md"}
                      >
                        <table className="table table-striped table-sm  project  my-0">
                          <thead>
                            <tr className="text-left">
                              <th>Email/Mobile</th>
                              <th>API Request</th>
                              <th>API Status / Response</th>
                              <th>Received</th>
                              {this.state.adminDtl?.user?.isAdmin ===
                                "admin" && <th>Route</th>}
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.apiResponse.map((itam, i) => (
                              <tr
                                className={
                                  itam.status === "success"
                                    ? "bg-success-table"
                                    : "bg-danger-table"
                                }
                                key={i}
                              >
                                <td className="text-left">
                                  {itam.email && `{`}
                                  {itam.email}
                                  {itam.email && `}`}
                                  <br />
                                  {itam.mobile && `{`}
                                  {itam.mobile}
                                  {itam.mobile && `}`}
                                </td>

                                <td className="text-left">
                                  <JSONPretty
                                    id="json-pretty"
                                    data={itam.workflows}
                                  ></JSONPretty>
                                </td>
                                <td className="text-left">
                                  <JSONPretty
                                    id="json-pretty"
                                    data={itam.message}
                                  ></JSONPretty>
                                </td>
                                <td className="text-left">
                                  {itam.submitted_on}
                                </td>
                                {this.state.adminDtl?.user?.isAdmin ===
                                  "admin" && (
                                    <td className="text-left">{itam.route_id}</td>
                                  )}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </Dialog>
                    )}

                    <div className="filter-option">
                      <h6 className="card-subtitle text-muted">Filter </h6>
                      <div className="row">
                        {/* <div className="col-md-4">
                          <div className="input-group mb-2 mr-sm-2">
                            <div className="input-group-text">
                              <FontAwesomeIcon icon={faCalendarCheck} />
                            </div>
                            <div>
                              <DatePicker
                                className="form-control btn-block"
                                dateFormat="yyyy/MM/dd"
                                value={this.state.dateFrom}
                                onChange={this.dateFrom}
                                selected={this.state.SelecteddateFrom}
                                placeholderText="From Date"
                              />
                            </div>
                          </div>
                        </div> */}
                        <div className="col-12 col-md-6 col-lg-4">
                          <div className="input-group mb-2 mr-sm-2">
                            <div className="input-group-text d-flex align-items-center justify-content-center" style={{ width: '40px' }}>
                              <FontAwesomeIcon icon={faCalendarCheck} />
                            </div>
                            <DatePicker
                              className="form-control"
                              dateFormat="yyyy/MM/dd"
                              value={this.state.dateFrom}
                              onChange={this.dateFrom}
                              selected={this.state.SelecteddateFrom}
                              placeholderText="From Date"
                            />
                          </div>
                        </div>
                        {/* <div className="col-md-4">
                          <div className="input-group mb-2 mr-sm-2">
                            <div className="input-group-text">
                              <FontAwesomeIcon icon={faCalendarCheck} />
                            </div>
                            <div>
                              <DatePicker
                                className="form-control btn-block"
                                dateFormat="yyyy/MM/dd"
                                value={this.state.dateTo}
                                onChange={this.dateTo}
                                selected={this.state.SelecteddateTo}
                                placeholderText="Date To"
                              />
                            </div>
                          </div>
                        </div> */}
                        <div className="col-12 col-md-6 col-lg-4">
                          <div className="input-group mb-2 mr-sm-2 d-flex">
                            <div className="input-group-text d-flex align-items-center justify-content-center" style={{ width: '40px' }}>
                              <FontAwesomeIcon icon={faCalendarCheck} />
                            </div>
                            <DatePicker
                              className="form-control"
                              dateFormat="yyyy/MM/dd"
                              value={this.state.dateTo}
                              onChange={this.dateTo}
                              selected={this.state.SelecteddateTo}
                              placeholderText="Date To"
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="input-group mb-2 mr-sm-2">
                            <div className="input-group-text">
                              <FontAwesomeIcon icon={faMobile} />
                            </div>
                            {this.state.channel === "email" ? (
                              <input
                                onChange={(event) =>
                                  this.setState({ email: event.target.value })
                                }
                                type="text"
                                placeholder="Enter Email"
                                className="form-control"
                              />
                            ) : (
                              <input
                                onChange={(event) =>
                                  this.setState({ mobile: event.target.value })
                                }
                                type="text"
                                placeholder="Enter Mobile NO"
                                className="form-control"
                              />
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <div className="input-group mb-2 mr-sm-2">
                            <div className="input-group-text">
                              <FontAwesomeIcon icon={faAddressBook} />
                            </div>
                            <input
                              disabled={this.state.channel !== "sms"}
                              onChange={(event) =>
                                this.setState({ senderid: event.target.value })
                              }
                              type="text"
                              placeholder="Enter Sender ID"
                              className="form-control"
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="input-group mb-2 mr-sm-2">
                            <div className="input-group-text">
                              <FontAwesomeIcon icon={faBan} />
                            </div>
                            <select
                              onChange={(event) =>
                                this.setState({ status: event.target.value })
                              }
                              className="form-control"
                            >
                              <option value=""> Select Status </option>
                              {this.setStatus()}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="row mt-3">
                        <div className="col-md-5"></div>
                        <div className="col-md-4">
                          <button
                            type="button"
                            onClick={() => {
                              handleUserLog("" , "sms_detailed_report_downloaded" , "sms" , "User Click on Template Summary tab in report" , "sms_report" , "" , "")
                              this.dataDownload();
                            }}
                            className="btn-success btn-sm btn-block ml-auto"
                          >
                            <FontAwesomeIcon icon={faDownload} /> Download
                            Reports{" "}
                          </button>
                          <small>
                            To download large file data, go to{" "}
                            <Link to="/dashboard/download-centre">
                              Download Center{" "}
                            </Link>
                          </small>
                        </div>
                        <div className="col-md-3">
                          <button
                            type="button"
                            onClick={() => {
                              this.detailsReport();
                            }}
                            className="btn-primary btn-block btn-sm ml-auto"
                          >
                            {" "}
                            <FontAwesomeIcon icon={faSearch} /> Filter Search{" "}
                          </button>
                        </div>
                      </div>
                    </div>

                    <hr />

                    <div className="row">
                      <div className="col-12 col-lg-12 col-xxl-12 d-flex">
                        <div
                          style={{ overflow: "scroll", height: 400 + "px" }}
                          className=" flex-fill"
                        >
                          <div className="">
                            {this.state.channel === "sms" &&
                              this.state.smsDetailsReportList !== "" ? (
                              <table className="table table-striped table-sm my-0">
                                <thead>
                                  <tr>
                                    <th>Status</th>
                                    <th>Mobile</th>
                                    <th>Cost</th>
                                    <th>Country</th>
                                    <th>Message</th>
                                    <th>Sender ID</th>
                                    <th>Submitted </th>
                                    <th>Delivered </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.smsDetailsReportList.map(
                                    (item, i) => (
                                      <tr>
                                        <td>
                                          {item.status === "Delivered" ? (
                                            <>
                                              <span className="badge btn-success">
                                                {item.status}
                                              </span>

                                              {this.isWithinLastSixDays(item.submitted_on) && (
                                                <FontAwesomeIcon
                                                  onClick={() =>
                                                    this.checkResponce(item.logid, item.route_id)
                                                  }
                                                  className="ml-2"
                                                  role="button"
                                                  color="green"
                                                  icon={faExclamationCircle}
                                                />
                                              )}
                                            </>
                                          ) : item.status === "Submitted" ? (
                                            <>
                                              <span className="badge bg-info">
                                                {item.status}
                                              </span>

                                              {this.isWithinLastSixDays(item.submitted_on) && (
                                                <FontAwesomeIcon
                                                  onClick={() => this.checkResponce(item.logid)}
                                                  className="ml-2"
                                                  role="button"
                                                  color="red"
                                                  icon={faExclamationCircle}
                                                />
                                              )}
                                            </>
                                          ) : item.status === "Failed" ? (
                                            <>
                                              <span
                                                data-tip
                                                data-for={"kannel_status" + i}
                                                style={{ cursor: "pointer" }}
                                                className="badge bg-danger"
                                              >
                                                {item.status}{" "}
                                                <FontAwesomeIcon
                                                  icon={faInfoCircle}
                                                  color="#77ff8e"
                                                />
                                              </span>
                                              <ReactTooltip
                                                html={true}
                                                id={"kannel_status" + i}
                                                place="bottom"
                                                effect="solid"
                                              >
                                                {item.kannel_status}
                                              </ReactTooltip>

                                              {this.isWithinLastSixDays(item.submitted_on) && (
                                                <FontAwesomeIcon
                                                  onClick={() => this.checkResponce(item.logid)}
                                                  className="ml-2"
                                                  role="button"
                                                  color="red"
                                                  icon={faExclamationCircle}
                                                />
                                              )}
                                            </>
                                          ) : (
                                            <span className="badge bg-danger">
                                              {item.status}
                                            </span>
                                          )}
                                        </td>


                                        <td>{item.mobile}</td>
                                        <td>{item.sms_cost}</td>
                                        <td>{item.country}</td>
                                        <td style={{ position: "relative" }}>
                                          <p className="mb-1">
                                            <small>
                                              <i>
                                                {item.dlt_entity_id ===
                                                  "1001487500000015900"
                                                  ? null
                                                  : "T.ID : " +
                                                  item.dlt_template_id}
                                              </i>
                                            </small>
                                          </p>
                                          <span
                                            className="badge bg-info"
                                            onClick={() =>
                                              this.handleButtonClick(i)
                                            }
                                            style={{
                                              cursor: "pointer",
                                              fontSize: 15,
                                            }}
                                          >
                                            {" "}
                                            <small
                                              style={{ fontSize: 10 + "px" }}
                                            >
                                              Message Show / Hide{" "}
                                            </small>{" "}
                                            <FontAwesomeIcon
                                              icon={faInfoCircle}
                                              color="yellow"
                                              size={5}
                                            />
                                          </span>
                                          {/* <ReactTooltip
                                            globalEventOff="click"
                                            className="tooltip"
                                            html={true}
                                            clickable={true}
                                            onClick={() => {
                                              ReactTooltip.show(this.fooRef);
                                            }}
                                            id={"registerTip" + i}
                                            place="bottom"
                                            effect="solid"
                                          >
                                            
                                          </ReactTooltip> */}

                                          {this.state.isPopoverOpen === i && (
                                            <div ref={this.popupRef} className="message_box ">
                                              <div dangerouslySetInnerHTML={{ __html: item.message }}></div>
                                            </div>

                                          )}
                                        </td>
                                        <td>{item.sender_id}</td>
                                        <td>{item.submitted_on}</td>
                                        <td>{item.delivered_on}</td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            ) : (
                              <div className="text-center">
                                <div className="card-body">
                                  <img
                                    alt="Empty Data"
                                    className="project-empty-img"
                                    src={EmptyImg}
                                  />
                                  <small>
                                    {this.state.responceMessage} in{" "}
                                    <strong> {this.state.channel} </strong>{" "}
                                    Between {this.state.dateFrom} to{" "}
                                    {this.state.dateTo}{" "}
                                  </small>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
          <DashboardFooter />
        </div>
      </div>
    );
  }
}

export default SmsDetailReports;